import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithEditing(edit, toggleActive) {
    //console.log(edit);
    //console.log(toggleActive);

	return class extends GridCell {
		render() {
			return (
				<td>
					<button
						className="admin-k-button "
						onClick={() => {
							edit(this.props.dataItem);
						}}
					>
						<i className="fas fa-pen"></i>
					</button>
                    &nbsp;{
                        toggleActive !== null ?
                            
                                this.props.dataItem.isActive !== null ? (
                                    <button
                                        className="admin-k-button "
                                        onClick={() => {
                                            swal({
                                                title: 'Are you sure?',
                                                text: `Deactivating, ${this.props.dataItem.organizationName}  will  no longer be available `,
                                                icon: 'warning',
                                                buttons: {
                                                    cancel: 'CANCEL',
                                                    confirm: 'OK'
                                                },
                                                dangerMode: true
                                            }).then((value) => (value ? toggleActive(this.props.dataItem) : null));
                                        }}
                                    >
                                        <i className="fas fa-times-circle"></i>
						    </button>
                                ) : (
                                        <button
                                            className="admin-k-button "
                                            onClick={() => {
                                                swal(
                                                    `Are you sure you want to re-activate ${this.props.dataItem.name} ?`
                                                ).then((value) => (value ? toggleActive(this.props.dataItem) : null));
                                            }}
                                        >
                                            <i className="fas fa-check-circle"></i>
						    </button>
                                    )
                             : (
                                
                                ""
                                
                                )}

				</td>
			);
		}
	};
}
